import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ml-4 capitalize" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " / ", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, " / ", -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " / ", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " / ", -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, " / ", -1)
const _hoisted_12 = { key: 1 }

import { computed, ref } from "vue";
import { useStore }      from "vuex";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store       = useStore();

const path        = computed( () => store.state.media.path );

const breadcrumbs = computed( () => {
    let pathArray = [];

    if ( path.value && path.value !== 'media' ) {
        pathArray = path.value.replace( 'media', '' ).split( '/' );
    }

    pathArray[ 0 ] = 'Root';

    return pathArray;
} );

const hideBreadcrumbsPart = ref( true );

// Functions
const toggleBreadcrumbs = (): void => {
    hideBreadcrumbsPart.value = !hideBreadcrumbsPart.value;
}

const goToBreadcrumb = async ( index: any ): Promise<void> => {
    if ( index === 0 ) {
        await store.dispatch( "media/setPath", null );
    } else {
        await store.dispatch( "media/setPath", 'media/' + breadcrumbs.value.slice( 1, index + 1 ).join('/') );
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(breadcrumbs).length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goToBreadcrumb( 0 ))),
            class: "cursor-pointer"
          }, "/ " + _toDisplayString(_unref(breadcrumbs)[ 0 ]), 1),
          (_unref(breadcrumbs).length > 4)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", {
                  onClick: toggleBreadcrumbs,
                  class: "cursor-pointer"
                }, " / " + _toDisplayString(hideBreadcrumbsPart.value ? '...' : '(hide)'), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbs), (breadcrumb, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("span", { key: index }, [
                    (( index > 0 && index < ( _unref(breadcrumbs).length - 3 ) ))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onClick: ($event: any) => (goToBreadcrumb( index )),
                          class: "cursor-pointer"
                        }, [
                          _hoisted_3,
                          _createTextVNode(" " + _toDisplayString(breadcrumb), 1)
                        ], 8, _hoisted_2))
                      : _createCommentVNode("", true)
                  ])), [
                    [_vShow, !hideBreadcrumbsPart.value]
                  ])
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbs), (breadcrumb, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                    (index === ( _unref(breadcrumbs).length - 1 ))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _hoisted_5,
                          _createTextVNode(" " + _toDisplayString(breadcrumb), 1)
                        ]))
                      : (( index >= ( _unref(breadcrumbs).length - 3 ) ))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            onClick: ($event: any) => (goToBreadcrumb( index )),
                            class: "cursor-pointer"
                          }, [
                            _hoisted_7,
                            _createTextVNode(" " + _toDisplayString(breadcrumb), 1)
                          ], 8, _hoisted_6))
                        : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 64))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(breadcrumbs), (breadcrumb, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, [
                  (index === ( _unref(breadcrumbs).length - 1 ))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _hoisted_9,
                        _createTextVNode(" " + _toDisplayString(breadcrumb), 1)
                      ]))
                    : (( index > 0 ))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          onClick: ($event: any) => (goToBreadcrumb( index )),
                          class: "cursor-pointer"
                        }, [
                          _hoisted_11,
                          _createTextVNode(" " + _toDisplayString(breadcrumb), 1)
                        ], 8, _hoisted_10))
                      : _createCommentVNode("", true)
                ]))
              }), 128))
        ], 64))
      : (_openBlock(), _createElementBlock("span", _hoisted_12, "/ " + _toDisplayString(_unref(breadcrumbs)[ 0 ]), 1))
  ]))
}
}

})